<template>
    <div id="app">
<!--        <router-view/>-->
      <div style="color: #333333;font-size: 24px;padding: 40px;margin: 0 auto;text-align: center">网站升级维护中...</div>
    </div>
</template>

<script>
export default {
    name: 'App'
}
</script>

<style>
    html, body, #app{
        width: 100%;
        height: 100%;
        margin: 0px;
        padding: 0px;
        font-size: 10px;
        font-family: Microsoft YaHei;
    }
    ::-webkit-scrollbar-track-piece {
        background-color: rgba(0, 0, 0, 0);
    }
    ::-webkit-scrollbar {
        width: 9px;
        height: 9px;
    }
    ::-webkit-scrollbar-thumb {
        background-color:rgba(0, 0, 0, 0.6);
        background-clip: padding-box;
        height: 28px;
        border-radius: 9px;
    }
    ::-webkit-scrollbar-thumb:hover {
        background-color: rgba(0, 0, 0, 0.9);
        border-radius: 9px;
    }
</style>



// WEBPACK FOOTER //
// src/App.vue



// WEBPACK FOOTER //
// src/App.vue